<template>
	<div id="planreportinfo">
		<HrrBreadcrumb PMname="岗位计划管理" CMname="单位基础信息管理" />
		<HrrDetailLayout>
			<template slot="head" >
				{{title}}
			</template>
			<template slot="Form" >
				<el-form status-icon :model="postform" ref="postform" :rules="postrules" label-width="160px" class="el-form-module" :hide-required-asterisk="!isAddOrEdit" >
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="计划" prop="planId">
                                <el-select  v-model="postform.planId" value-key="planId" placeholder="请选择" :disabled="!isAddOrEdit">
                                    <el-option v-for="item in planIdData" :key="item.planId" :label="item.planName" :value="item.planId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="单位名称：" prop="post">
                                <el-input v-model="postform.post" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.post}}
                                </span>
                            </el-form-item> -->
                            <el-form-item label="单位性质：" prop="propertyType">
                                <el-input v-model="postform.propertyType" v-if="isAddOrEdit" type="textarea"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.propertyType}}
                                </span>
                            </el-form-item>
                            <el-form-item label="注册地址：" prop="registerAddress">
                                <el-input v-model="postform.registerAddress" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.registerAddress}}
                                </span>
                            </el-form-item>
                            <el-form-item label="编制数：" prop="planNum">
                                <el-input v-model="postform.planNum" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                   {{postform.planNum}}
                                </span>
                            </el-form-item>
                            <el-form-item label="现有数：" prop="onjobNum">
                                <el-input v-model="postform.onjobNum" v-if="isAddOrEdit" @blur="checkLeckNum()"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.onjobNum}}
                                </span>
                            </el-form-item>
                            <el-form-item label="缺编数：" prop="lackNum">
                                <el-input v-model="postform.lackNum" v-if="isAddOrEdit" ></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.lackNum}}
                                </span>
                            </el-form-item>
                            <el-form-item label="年底拟退休人数：" prop="retireNum">
                                <el-input v-model="postform.retireNum" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.retireNum}}
                                </span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="集体户登记住址："  prop="groupAddress" label-width="160px">
                                <el-input v-model="postform.groupAddress" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                   {{postform.groupAddress}}
                                </span>
                            </el-form-item>
                            <el-form-item label="集体户户口登记机关：" prop="registerInstitution" label-width="170px">
                                <el-input v-model="postform.registerInstitution" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                   {{postform.registerInstitution}}
                                </span>
                            </el-form-item>
                            <el-form-item label="联系人：" prop="linkman">
                                <el-input v-model="postform.linkman" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                   {{postform.linkman}}
                                </span>
                            </el-form-item>
                            <el-form-item label="联系电话：" prop="phone" >
                                <el-input v-model="postform.phone" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.phone}}
                                </span>
                            </el-form-item>
                            <el-form-item label="通讯地址：" prop="linkAddress" >
                                <el-input v-model="postform.linkAddress" v-if="isAddOrEdit" type="textarea"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.linkAddress}}
                                </span>
                            </el-form-item>
                            <el-form-item label="邮政编码：" prop="postCode">
                                <el-input v-model="postform.postCode" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.postCode}}
                                </span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="long-label">
                            <el-form-item label="主营业务 （主要职责）：" prop="mainWork" label-width="200px">
                                <el-input v-model="postform.mainWork" v-if="isAddOrEdit" type="textarea" :autosize="{ minRows: 4, maxRows: 4}"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.mainWork}}
                                </span>
                            </el-form-item>
                            <el-form-item label="备注：" prop="remark" label-width="200px">
                                <el-input v-model="postform.remark" v-if="isAddOrEdit" type="textarea" :autosize="{ minRows: 4, maxRows: 4}"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.remark}}
                                </span>
                            </el-form-item>
                            <el-form-item label="发布招聘信息时公布的联系方式：" prop="publicInfo" label-width="260px">
                                <el-input v-model="postform.publicInfo" v-if="isAddOrEdit"></el-input>
                                <span v-if="!isAddOrEdit">
                                    {{postform.publicInfo}}
                                </span>
                            </el-form-item>
                        </el-col>
                    </el-row>
				</el-form>
			</template>
			<template slot="buttons" >
				<el-button type="primary" @click="submitMForm('postform')" v-if="isAddOrEdit">提 交</el-button>
				<el-button  @click="resetMForm('postform')" v-if="isAddOrEdit">重 置</el-button>
				<el-button type="info" @click="returnMForm()" >返 回</el-button>
			</template>
		</HrrDetailLayout>
	</div>
</template>
<script>
	export default {
		name: 'plan_reportinfo_Detail',
		data(){
			return{
				postform:{
					planId:"",
                    propertyType:"",
                    registerAddress:"",
                    planNum:"",
                    onjobNum:"",
                    lackNum:"",
                    retireNum:"",
                    groupAddress:"",
                    registerInstitution:"",
                    linkman:"",
                    phone:"",
                    linkAddress:"",
                    postCode:"",
                    publicInfo:"",
                    mainWork:"",
                    remark:"",
					status:"",
                    status_str:""
				},
                planform: {
                    planId: ""
                },
                planIdData: [],
				postrules:{
					planId:[ { required: true, message: '请选择计划' , trigger: 'change'}],
					propertyType:[ { required: true, message: '请输入单位性质' , trigger: 'blur'}],
					registerAddress:[ { required: true, message: '请输入注册地址' , trigger: 'blur'}],
                    /*planNum:[ { required: true, message: '请输入编制数' , trigger: 'blur'}],
                    onjobNum:[ { required: true, message: '请输入现有数' , trigger: 'blur'}],
                    lackNum:[ { required: true, message: '请输入缺编数' , trigger: 'blur'}],
                    retireNum:[ { required: true, message: '请输入年底拟退休人数' , trigger: 'blur'}],*/
                    linkman:[ { required: true, message: '请选择计划' , trigger: 'blur'}],
                    phone:[ { required: true, message: '请输入联系电话' , trigger: 'blur'}],
                    mainWork:[ { required: true, message: '请输入主营业务' , trigger: 'blur'}],
                    groupAddress:[ { required: true, message: '请输入集体户登记地址' , trigger: 'blur'}],
                    registerInstitution:[ { required: true, message: '请输入集体户户口登记机关' , trigger: 'blur'}],
                    linkAddress:[ { required: true, message: '请输入通讯地址' , trigger: 'blur'}],
                    publicInfo:[ { required: true, message: '请输入发布招聘信息时公布的联系方式' , trigger: 'blur'}],
				},
				title:"",
				isAddOrEdit:true,
			}
		},
		methods:{
			submitMForm:function(formName){
                var Hrrtype=this.$route.params.type; //类型
                if(Hrrtype=="add"){
                   this.postform.oinfoId="";
                }
                if(Hrrtype=="edit"){Hrrtype="modify"}
				this.$refs[formName].validate((valid) =>{
					if (valid) {
                        var Vuethis=this;
                        var postUrl = (Hrrtype == "modify") ? this.$api.plan.reportInfoModify : this.$api.plan.reportInfoAdd ;
						this.$hrraxios.post(postUrl,this.postform)
						.then(function(response){
                            var data=response.data;
                            // console.log(data)
							if(data.success==true)
							{
                                Vuethis.$message.success("提交成功");
								Vuethis.$router.push({path:'/plan/report/info'});
							}else{
                                Vuethis.$message.error(data.prompt);
                            }
						}).catch(function(error){
							console.log(error);
						})
					} else {
						return false;
					}
				});
			},
			resetMForm:function(formName) {
				this.$refs[formName].resetFields();
			},
			returnMForm:function(){
				this.$router.go(-1);
			},
            //判断缺编数
            checkLeckNum(){
                var planNum=this.postform.planNum;
                var onjobNum=this.postform.onjobNum;
                var lackNum=parseInt(planNum)-parseInt(onjobNum);
                //缺编数到底等不等于编制数-现有数,等于
                this.postform.lackNum=lackNum;
            },
            initParamsData(){
                this.$common.getplanlist(this,"planIdData",this.initData);
                this.$common.getStatus({forTable:"hrr_post"},"statusData",this);
            },
			initData(){
				var Hrrtype=this.$route.params.type; //类型
				//if(Hrrtype!="add"){
                if(this.$route.meta.row){
                   this.postform=this.$route.meta.row;
                   this.$route.meta.row={};
                }
                this.postform.planId=this.planIdData[0].planId;
				//}
				if(Hrrtype=="view"){
					this.title="查看单位基础信息";
					this.isAddOrEdit=false;
				}
				if(Hrrtype=="edit"){
					this.title="编辑单位基础信息";
					this.isAddOrEdit=true;
				}
				if(Hrrtype=="add"){
					this.title="新增单位基础信息";
					this.isAddOrEdit=true;
				}
			},

		},
		created:function(){
			this.initParamsData();
		}
	}
</script>
<style scoped>
.el-form-module{width:100%;}
</style>
